import React, { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import Tracking from "@t8891/tracking";
import Footer from "../components/common/footer";
import { g4 } from "../utils/helper";
import { useAtom } from "jotai";
import qs from "qs";
import Cookies from "js-cookie";
import { initTracking } from "@Lib/jotai/tracking";
import WebsiteNav from "@Components/websiteNav";
import AdGlobalPopad from "@Components/ad/AdGlobalPopad";
import { activityAtom } from "@Lib/jotai/activity";
import { postCollectData } from "@Services/common";
import { onINP } from "web-vitals";
import { htmlTreeAsString } from "@t8891/helper";
import AppDownload from "@Components/common/AppDownload";
import { clarity } from "react-microsoft-clarity";
import "@Styles/global.less";
import "@Styles/base.css";
import { loginAtom } from "@Lib/jotai/login";
import { useDebounceEffect } from "ahooks";
import { initClarity, initComsorcetag } from "@t8891/third-parties";
import initializeFireBase from "../utils/initializeFireBase";
import AdIframeImage from "@Components/ad/AdFrame_v2";
import SinglePageNav from "@Components/singlePageNav";
import { pkListAtom } from "@Lib/jotai/pkCompare";
import userBehavedTrackingExposure from "utils/userBehavedTrackingExposure";

const IS_PRODUCTION = process.env.SERVER_ENV === "production";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

interface IProps {
  params: {
    AdTopBanner?: boolean;
    nav?: "" | "SlimNav" | "DefaultFixedNav";
    footer?: "" | "Footer";
    needRTBH?: boolean;
    webPageNav?: boolean;
    singlePageNav?: boolean;
    appDownload?: boolean;
  };
}
const BaseLayout: React.FC<IProps> = ({ children, params }) => {
  const {
    AdTopBanner = true,
    nav = "",
    footer = "Footer",
    needRTBH = false,
    webPageNav = true,
    singlePageNav = false,
    appDownload = true,
  } = params;
  const [tracking, updateInitTracking] = useAtom(initTracking);
  const [, updateActivityInfo] = useAtom(activityAtom);
  const [loginInfo, updateLoginInfo] = useAtom(loginAtom);
  const [globalPkList, initGlobalPkList] = useAtom(pkListAtom);

  const storedData = localStorage.getItem("globalPkComparison");
  const initialData = storedData !== "null" && storedData ? JSON.parse(storedData) : [];

  useEffect(() => {
    // 初始化g4 Index\_js\gtm.blade.php 已初始化
    // window.gtag("js", new Date());
    // window.gtag("config", "G-4YCT4M05RT", {
    //   sub_platform: "PC",
    //   device_id: localStorage.getItem("uuid"),
    //   user_id: Cookies.get("mid"),
    // });

    if (!!window.dimensions) {
      g4("remarketing", window.dimensions);
    }
    let { globalSource } = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (!!globalSource) {
      Cookies.set("globalSource", globalSource, { expires: 10 });
      Cookies.set("globalSessionSource", globalSource);
    }
    const userMessage = localStorage.getItem("userMessage");
    // 获取活动接口
    updateActivityInfo({ name: "inquiry-sale" });
    // 录屏监控
    clarity.init("migw9xduwf");
    //更新登录状态
    updateLoginInfo();
    // fb消息推送
    initializeFireBase();

    /** 处理埋点 */
    const tracking = new Tracking({
      debug: !IS_PRODUCTION,
      gaParams: {
        user_id: !!userMessage ? JSON.parse(userMessage).mId : "",
        device_id: localStorage.getItem("uuid"),
        sub_platform: "PC",
      },
      trackApi: !IS_PRODUCTION
        ? "https://assets.8891.com.tw/track-debug/pc/c.8891.com.tw/new-car-config-track.json"
        : "https://assets.8891.com.tw/track/pc/c.8891.com.tw/new-car-config-track.json",
    });
    // 手动上报曝光埋点
    userBehavedTrackingExposure(tracking);

    updateInitTracking(tracking);
    // 全局pk数据
    if (globalPkList.length === 0 && initialData.length > 0) {
      initGlobalPkList(initialData);
    }

    try {
      onINP(
        function (info) {
          if (info?.value > 200) {
            postCollectData({
              es_tag: "newcar_touch_next_inp_analytics",
              // device_id: device_id,
              url: window.location.href,
              uri: window.location.origin + window.location.pathname,
              ua: navigator.userAgent,
              inpInfo: {
                ...info,
                entries: info.entries.map((entry) => ({
                  ...entry,
                  name: entry.name,
                  entryType: entry.entryType,
                  duration: entry.duration,
                  xpath: htmlTreeAsString(entry.target),
                })),
              },
              pageRoute: window?.page_route || "",
            });
          }
        },
        { reportAllChanges: true },
      );
    } catch (e) {
      console.error(e);
    }

    if (needRTBH) {
      setTimeout(() => {
        (function (w, d, dn, t) {
          w[dn] = w[dn] || [];
          w[dn].push({ eventType: "init", value: t, dc: "asia" });
          var f = d.getElementsByTagName("script")[0],
            c = d.createElement("script");
          c.async = true;
          c.src = "https://tags.creativecdn.com/tXb3jYXmh7pe5qFj06V7.js";
          f?.parentNode?.insertBefore(c, f);
        })(window, document, "rtbhEvents", "tXb3jYXmh7pe5qFj06V7");
      }, 4000);
    }

    // 初始化 comsorcetag
    initComsorcetag("34024275");
  }, []);

  useDebounceEffect(
    () => {
      // ----------------- 微软录屏追踪 -----------------
      initClarity("migw9xduwf", "G-4YCT4M05RT", loginInfo?.data?.m_id || "");
      // ----------------- 微软录屏追踪 end -----------------
    },
    [loginInfo],
    { wait: 500 },
  );

  return (
    <QueryClientProvider client={queryClient}>
      {webPageNav && (
        <WebsiteNav>
          {nav === "DefaultFixedNav" && AdTopBanner && (
            <div
              style={{
                width: "1190px",
                height: "120px",
                margin: "0 auto",
                position: "relative",
                background: "#9e9e9e",
              }}
            >
              <AdIframeImage
                slot={"/173427088/newcar-pc-homepage-topbanner"}
                size={[["fluid"], [1190, 120]]}
                width={1190}
                height={120}
                styles={{ width: "1190px", height: "120px", margin: "0 auto", position: "relative" }}
              />
            </div>
          )}
        </WebsiteNav>
      )}

      {singlePageNav && <SinglePageNav />}

      <section>{children}</section>

      {!!footer && <Footer />}

      {appDownload && <AppDownload />}

      <AdGlobalPopad blacklist={["/campaigns/:any*", "/iframeSignIn"]} />
    </QueryClientProvider>
  );
};

export default BaseLayout;
